import axios from "axios";

import { Constant } from "../../Utils/Constant/Constant";
import { ApiErrorHandler } from "./ApiErrorHandler";

// this contains the main connection Information
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "https://localhost:7068",
});

export const get = async (url, config = {}) => {
  let token1 = localStorage.getItem("doctore");

  try {
    const response = await api.get(
      url,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token1}`,
        },
      },
      config,
    );
    return ApiErrorHandler(response, Constant.GET);
  } catch (exception) {
    return ApiErrorHandler(exception.response, Constant.GET);
  }
};

export const post = async (url, data = {}, config = {}) => {
  let token1 = localStorage.getItem("doctore");

  try {
    const response = await api.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token1}`,
      },
    });
    return ApiErrorHandler(response, Constant.POST);
  } catch (exception) {
    return ApiErrorHandler(exception.response, Constant.POST);
  }
};

export const postFile = async (url, data = {}, config = {}) => {
  let token1 = localStorage.getItem("doctore");

  try {
    const response = await api.post(url, data, {
      responseType: "blob",
      ...config,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token1}`,
        ...(config.headers || {}),
      },
    });

    return {
      type: 0,
      data: response.data,
      headers: response.headers,
      status: response.status,
    };
  } catch (exception) {
    const response = exception?.response;
    let message = "server-error";
    let errorData = "";

    if (response?.data instanceof Blob) {
      if (response.data.size > 0) {
        const blobText = await response.data.text();

        if (blobText) {
          try {
            const parsed = JSON.parse(blobText);
            message = parsed?.message || message;
            errorData = parsed?.data || errorData;
          } catch {
            message = blobText;
          }
        }
      }
    } else if (response?.data) {
      message = response.data?.message || response.data || message;
      errorData = response.data?.data || errorData;
    }

    if (!response) {
      return { type: 3, data: "", message: "server-error" };
    }

    return {
      type: response.status === 400 ? 2 : 3,
      data: errorData,
      message,
      headers: response.headers,
      status: response.status,
    };
  }
};

export const put = async (url, data = {}, config = {}) => {
  let token1 = localStorage.getItem("doctore");

  try {
    const response = await api.put(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token1}`,
      },
    });
    return ApiErrorHandler(response, Constant.PUT);
  } catch (exception) {
    return ApiErrorHandler(exception.response, Constant.PUT);
  }
};

export const deletion = async (url, config = {}) => {
  let token1 = localStorage.getItem("doctore");
  try {
    const response = await api.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token1}`,
      },
    });
    return ApiErrorHandler(response, Constant.DELETE);
  } catch (exception) {
    return ApiErrorHandler(exception.response, Constant.DELETE);
  }
};
